import React from 'react';
import AjliinHusnegt from './ajliinHusnegt';

const PageList = () => <AjliinHusnegt />;

export default PageList;
